import { render, staticRenderFns } from "./user_manage_static.vue?vue&type=template&id=1e4b53d2&scoped=true&"
import script from "./user_manage_static.vue?vue&type=script&lang=js&"
export * from "./user_manage_static.vue?vue&type=script&lang=js&"
import style0 from "./user_manage_static.vue?vue&type=style&index=0&id=1e4b53d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4b53d2",
  null
  
)

export default component.exports